import { Routes } from '@angular/router';
import { InternalLayoutComponent } from '../layouts';
import { AuthGuard } from '../../shared/auth/services';
import { AdminImportRequestComponent } from './pages/admin-import-request';
import { AdminImportRequestsComponent } from './pages/admin-import-requests';
import { AdminMainComponent } from './layout/main';
import { AdminPropertyComponent } from './pages/admin-property';
import { AdminPropertiesComponent } from './pages/admin-properties';
import { AdminPropertyExportMapComponent } from './pages/admin-property-export-map';
import { AdminPortfoliosComponent } from './pages/admin-portfolios';
import { AdminPortfolioComponent } from './pages/admin-portfolio';
import { SpAdminAccessGuard } from 'app/shared/auth/guards/sp-admin-access.guard';
import { AdminUsersComponent } from './pages/admin-users/admin-users.component';
import { AdminPortfolioEditUserComponent } from './pages/admin-portfolio-edit-user';
import { AdminPortfolioEditPropertyComponent } from './pages/admin-portfolio-edit-property';
import { AdminUserComponent } from './pages/admin-user/admin-user.component';
import { AdminSettingsComponent } from './pages/admin-settings';

export const adminRoutes: Routes = [
  {
    path: 'useraccount',
    component: InternalLayoutComponent,
    canActivate: [AuthGuard],
    data: { roles: ['Admin', 'PortfolioAdmin'] },
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'admin',
        component: AdminMainComponent,
        children: [
          { path: 'portfolios', component: AdminPortfoliosComponent, title: 'Admin - Portfolios', canActivate: [SpAdminAccessGuard] },
          { path: 'portfolios/:workspaceId', component: AdminPortfolioComponent, title: 'Admin - Edit Portfolio', canActivate: [SpAdminAccessGuard] },
          { path: 'portfolios/:workspaceId/edit-user/:id', component: AdminPortfolioEditUserComponent, title: 'Admin - Edit Portfolio User', canActivate: [SpAdminAccessGuard] },
          { path: 'portfolios/:workspaceId/edit-property/:id', component: AdminPortfolioEditPropertyComponent, title: 'Admin - Edit Portfolio Property', canActivate: [SpAdminAccessGuard] },
          { path: 'properties', component: AdminPropertiesComponent, title: 'Admin - Properties' },
          { path: 'properties/:id', component: AdminPropertyComponent, title: 'Admin - Edit Property' },
          { path: 'properties/:id/export-map', component: AdminPropertyExportMapComponent, title: 'Admin - Export Map' },
          { path: 'import-requests', component: AdminImportRequestsComponent, title: 'Admin - Data Import Requests' },
          { path: 'import-requests/:id', component: AdminImportRequestComponent, title: 'Admin - Import Request Details' },
          { path: 'users', component: AdminUsersComponent, title: 'Admin - Users', canActivate: [SpAdminAccessGuard] },
          { path: 'users/:id', component: AdminUserComponent, title: 'Admin - Edit User', canActivate: [SpAdminAccessGuard] },
          { path: 'settings', component: AdminSettingsComponent, title: 'Admin - Settings' },
          { path: '', redirectTo: 'properties', pathMatch: 'full' },
        ]
      },
    ]
  }
];
